// Colunas elegíveis da tabela de contratos, na ordem em que a tela as exibe.
// As chaves precisam bater com os campos de POST /api/contracts/search e com as
// gravadas em user_settings.settings_table_contracts pelo backend-core.
//
// As três colunas novas ficam sem ordenação de propósito: `coverage_value` vem de
// subquery por linha e ordenar por ela sairia caro.
export const CONTRACT_TABLE_COLUMNS = [
  { key: 'contract_status_name', label: 'Status', sortable: true },
  { key: 'days_count', label: 'Dias', sortable: true },
  { key: 'consultant_name', label: 'PN', sortable: true },
  { key: 'customer_name', label: 'Cliente', sortable: true },
  { key: 'financial_solution_name', label: 'Solução Financeira', sortable: true },
  { key: 'gross_value', label: 'LTV Bruto', sortable: true },
  { key: 'monthly_premium', label: 'Prêmio Mensal', sortable: true },
  { key: 'coverage_value', label: 'Valor da Cobertura', sortable: false },
  { key: 'specialist_name', label: 'Especialista', sortable: false },
  { key: 'specialist_level', label: 'Nível do Especialista', sortable: false },
  { key: 'contract_date', label: 'Data do contrato', sortable: true },
  { key: 'signed_at', label: 'Data da assinatura', sortable: true },
  { key: 'actions', label: 'Ações' },
]

// Colunas que identificam e operam o contrato: nunca podem ser ocultadas.
// O backend reforça a mesma regra em UserSettingController::CONTRACTS_REQUIRED_COLUMNS.
export const CONTRACT_REQUIRED_COLUMNS = ['customer_name', 'actions']

export const isRequiredContractColumn = key => CONTRACT_REQUIRED_COLUMNS.includes(key)

export const customizableContractColumns = () => CONTRACT_TABLE_COLUMNS
  .filter(column => !isRequiredContractColumn(column.key))

export const defaultContractColumnSettings = () => CONTRACT_TABLE_COLUMNS
  .reduce((settings, column) => ({ ...settings, [column.key]: true }), {})
